import * as types from "../../types/stores.types";

export const actionChangeStatusShowModalMyDiscounts = (status_show_modal) => ({
    type: types.CHANGE_STATUS_SHOW_MODAL_MY_DISCOUNTS, payload: {status_show_modal}
});